import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import columns from "./columns";
import { formatAuth } from '@/utils/commonUtils'

const { WizContainer, modelUtils } = framework_tool;
const { WizSpin, WizForm, WizButton, WizRow, WizCol, WizBrowserExport } = component_tool;

class WizManageAuth extends WizContainer {
  componentName = "WizManageAuth";

  getData = () => {
    const {bizType, bizId} = this.props
    let bizType_ = bizType;
    if (bizType!=null && bizType===12){
      bizType_ = 39
    }
    this.doAction({
      path: "manageAuth/listByPage",
      payload: {
        key: "manageAuth@listByPage",
        apiParams: { bizType:bizType_, bizId },
      },
    });
  }

  _componentDidMount() {
    this.getData()
  }

   propsAndStateOnChange = {
    list: this._list.bind(this),
    save: this._save.bind(this),
  };

  _list(nextProps, nextState) {
    const { list } = nextProps;
    if (list.success) {
      return true;
    }
    wizNotice.error(list.msg)
    return false;
  }

  _save(nextProps, nextState) {
    let {changeModal } = this.props
    const { save } = nextProps;
    if (save.success) {
      wizNotice.success('保存成功')
      changeModal(false, true, true)
    } else {
      wizNotice.error(save.msg)
      return false;
    }
  }

  // 提交
  onSubmit = values => {
    const { bizType, bizId } = this.props
    values.authCmd = formatAuth(values.authCmd)
    values.bizId = bizId
    let bizType_ = bizType;
    if (bizType!=null && bizType===12){
      bizType_ = 39
    }
    values.bizType = bizType_
    this.doAction({
      path: "manageAuth/save",
      payload: {
        key: "manageAuth@save",
        apiParams: values
      }
    })
  }

  _authExport(authInfo) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '权限类型',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '权限范围',
        field: 'content',
        width: 160,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (authInfo) {
      let rows=[]
      let {orgIds, positionIds, positionCategoryIds, personIds, isAll} = authInfo
      let orgRow={},positionRow={},positionCategoryRow={},personRow = {}
      orgRow.name = '组织选择'
      orgRow.content = ''
      if (orgIds && Array.isArray(orgIds) && orgIds.length > 0) {
        let content = ''
        orgIds.forEach(org => {
          content += org['name'] + ','
        });
        orgRow.content = content.substring(0, content.length - 1)
      }
      rows.push(orgRow)

      positionRow.name = '岗位选择'
      positionRow.content = ''
      if (positionIds && Array.isArray(positionIds) && positionIds.length > 0) {
        let content = ''
        positionIds.forEach(org => {
          content += org['name'] + ','
        });
        positionRow.content = content.substring(0, content.length - 1)
      }
      rows.push(positionRow)

      positionCategoryRow.name = '岗位分类'
      positionCategoryRow.content = ''
      if (positionCategoryIds && Array.isArray(positionCategoryIds) && positionCategoryIds.length > 0) {
        let content = ''
        positionCategoryIds.forEach(org => {
          content += org['name'] + ','
        });
        positionCategoryRow.content = content.substring(0, content.length - 1)
      }
      rows.push(positionCategoryRow)

      personRow.name = '指定人员'
      personRow.content = ''
      if (isAll && isAll === 1) {
        personRow.content = '所有人'
      } else if (personIds && Array.isArray(personIds) && personIds.length > 0) {
        let content = ''
        personIds.forEach(org => {
         content += org['userName'] + '('+org['fullName']+'),'
        });
        personRow.content = content.substring(0, content.length - 1)
      }
      rows.push(personRow)

      WizBrowserExport({
        title: '管理权限信息',
        sheetName: '管理权限信息',
        columns: columnDefs.filter((_, index) => index),
        rows: rows,
        filename: '管理权限信息.xlsx',
      })
    }
  }

  _render() {
    const { manageAuthLoading, list } = this.props
    const formProps = {
      ref: 'form',
      columns: columns(list.data),
      onSubmit: this.onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizSpin spinning={manageAuthLoading}>
        <WizRow>
          <WizCol span={20}>
            <WizForm {...formProps} />
          </WizCol>
          <WizCol pull={2}>
            <WizButton onClick={() =>{
              if (list.data) {
                this._authExport(list.data)
              }
            }} type="export">导出</WizButton>
          </WizCol>
        </WizRow>

      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { manageAuth } = state;
  const list = modelUtils.getModelEntity(manageAuth,'manageAuth@listByPage');
  const save = modelUtils.getModelEntity(manageAuth,'manageAuth@save');
  const load = modelUtils.getLoadingState(state, "manageAuth");

  return {
    list,
    save,
    ...load,
  };
};

export default connect(mapStateToProps)(WizManageAuth);
